import SrKindEditor from "./index.vue";

SrKindEditor.install = function(Vue) {
  Vue.component(SrKindEditor.name, SrKindEditor);
};

export default SrKindEditor;



// WEBPACK FOOTER //
// ./packages/SrKindEditor/index.js